module.exports = __webpack_public_path__ + "img/loading-icon.2ef4e1a6.gif";